import { render, staticRenderFns } from "./ContentTermsOfUse.vue?vue&type=template&id=8916e420&"
import script from "./ContentTermsOfUse.vue?vue&type=script&lang=js&"
export * from "./ContentTermsOfUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports